import './components/old-main';
import {homepageSlider} from './components/homepage';
import { initContact } from './components/contact';
import {closeMenu} from './components/menu';
import {nosActivitesCardHeight} from './components/nos-activites';
import {
  sliderDeDirection,
  sliderDegestion,
  revolutionSlider,
  trustedPartner,
  sliderNews
} from './components/slickSlider'
import {ourValuesSecuritySlider} from './components/our-values';
import {realisationRelocateHeader} from './components/realitation-page';
import {chartPageHeader, chartPagePieChart, pageBarChart} from './components/chartPage';
import { newsPageShare } from './components/news-page';
import {historyPage} from './components/historyPage';
import {sliderEffect} from './components/developmentPage';

global.$ =  jQuery;

$(function() {
  homepageSlider();
  initContact($);
  closeMenu();
  sliderDeDirection();
  sliderDegestion();
  ourValuesSecuritySlider();
  revolutionSlider();
  realisationRelocateHeader();
  chartPageHeader();
  chartPagePieChart();
  pageBarChart();
  newsPageShare();
  historyPage();
  trustedPartner();
  sliderEffect();
  sliderNews();
});

$(window).on('load', function(){
  nosActivitesCardHeight();
})
